import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { getUserSuccess } from "../admin/actions";
import {
  GET_PLAYLISTS_REQUEST,
  getPlaylistsSuccess,
  getPlaylistsError,
  GET_SUBCRIPTIONSTATUS_REQUEST,
} from "./actions";

import { logoutRequest } from "../login/actions";
import { Env } from "../../env";

function* getPlaylistsRequest(action) {
  const { accessToken, userId } = action;
  let response, response1;

  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/${userId}/Playlists?filter={"include":"videos"}`,
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(
        getPlaylistsError("Une erreur s'est produite, veuillez réessayer.")
      );
      yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    }

    return;
  }

  yield put(getPlaylistsSuccess(response.data));
}
// function* getSubcriptionStatusRequest(action)
// {
//   let response;
//   const { accessToken,userId,user} = action;
//  // console.log(JSON.stringify(action));
//   try {
//     response = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/status`, {
//       headers: { Authorization: accessToken },
//     });
//   } catch (err) {
//     if (err.response && err.response.status === 401) {
//      // yield put(logoutRequest());
//      console.log('error');
//     } else {
//      // yield put(getSubcriptionError("Somthing is wrong"));
//     }

//     return;
//   }

//   yield put(getUserSuccess(user,response.data));
// }
export default function* watchGetPlaylistsRequest() {
  yield takeLatest(GET_PLAYLISTS_REQUEST, getPlaylistsRequest);
  // yield takeLatest(GET_SUBCRIPTIONSTATUS_REQUEST,getSubcriptionStatusRequest);
}



// WEBPACK FOOTER //
// ./src/pages/playlists/saga.js